<template>
  <div>
    <span class="position-relative">
      <img
        class="use-existing rounded-circle user-avatar icon-account"
        src="@/assets/images/avatars/avatar.svg"
        alt="User Avatar"
      />
      <!-- TODO: -->
      <!-- WHEN CLICKING delete-existing, account should be removed -->
      <span class="delete-existing">x</span>
    </span>
  </div>
</template>

<script>
export default {
  props: [{ url: "@/assets/images/avatars/avatar.svg" }]
};
</script>

<style lang="scss" scoped>
</style>